// extracted by mini-css-extract-plugin
export default {"FooterPriceMainBlock":"FooterPrice_FooterPriceMainBlock__cWc+z","FooterPriceTitle":"FooterPrice_FooterPriceTitle__VCY9w"};